export function normalizeType(type) {
	return type
		.split('::')
		.map((fragment) => fragment.toLowerCase())
		.join('/');
}
